
import { createAsyncThunk } from "@reduxjs/toolkit";
import { BillingService } from "../../services/billing.service";

export const getSubscriptions = createAsyncThunk(
  "[billing]/getSubscriptions",
  async () => await BillingService.getSubscriptions()
);

